import React from 'react';

type EmailSnapshotItem = {
  snapshotId?: string;
  to?: string;
  from?: string;
  subject?: string;
  emailType?: string;
  previewUrl?: string;
};

export const EmailSnapshotLogEntry: React.FC<{ entry: any }> = ({ entry }) => {
  const items: EmailSnapshotItem[] = Array.isArray(entry?.Entries) ? entry.Entries : [];
  return (
    <div>
      {items.map((it, idx) => (
        <div key={idx} className="mb-2 p-2 border rounded">
          <table className="table table-sm m-0">
            <tbody>
              {it.emailType ? (
                <tr>
                  <td className="text-muted">Type</td>
                  <td>{it.emailType}</td>
                </tr>
              ) : null}
              <tr>
                <td className="text-muted">From</td>
                <td>{it.from || '-'}</td>
              </tr>
              <tr>
                <td className="text-muted">To</td>
                <td>{it.to || '-'}</td>
              </tr>
              <tr>
                <td className="text-muted">Subject</td>
                <td>{it.subject || '-'}</td>
              </tr>
              <tr>
                <td className="text-muted">Preview</td>
                <td>
                  <a className="btn btn-outline-primary btn-sm" href={it.previewUrl ?? '#'} target="_blank" rel="noopener noreferrer">
                    Open preview
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default EmailSnapshotLogEntry;